/* eslint-disable react/no-did-update-set-state */
//we can probably fix the above error but it's not completely straightforward
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MetaTags from 'react-meta-tags';
import * as blogActions from '../../actions/blogActions';
import Loading from '../common/Loading';
import ShareService from '../../services/shareService.js';
import articleTypes from '../../constants/articleTypes';
import BlogSummaryItem from './BlogSummaryItem';
import Advert from '../common/Advert';
import * as qs from 'query-string';
import pull from 'lodash/pull';

class BlogPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.getTitle = this.getTitle.bind(this);
        this.getMetaDescription = this.getMetaDescription.bind(this);
        this.getHeader = this.getHeader.bind(this);
        this.getIntro = this.getIntro.bind(this);
        this.loadNextPage = this.loadNextPage.bind(this);
        this.selectSection = this.selectSection.bind(this);
        this.toggleTag = this.toggleTag.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.getSectionClass = this.getSectionClass.bind(this);
        this.getTagClass = this.getTagClass.bind(this);
        this.getPosts = this.getPosts.bind(this);
        const params = qs.parse(this.props.location.search);
        this.state = {
            selectedSection: null,
            selectedTags: [],
            initialPage: params.page || 1,
        };
    }

    componentWillMount() {        
        this.getPosts(this.state.initialPage);
        this.props.actions.getSections(this.props.articleType);
        this.props.actions.getTags(this.props.articleType);
    }

    componentDidMount() {       
        
    }

    componentDidUpdate(prevProps, prevState) {        
        if(this.props.articleType != prevProps.articleType) {
            this.setState({
                selectedSection: null,
                selectedTags: []
            }, () => {
                this.getPosts();
            });
            this.props.actions.getSections(this.props.articleType);
            this.props.actions.getTags(this.props.articleType);
        }
    }

    loadNextPage(event) {
        event.preventDefault();
        this.getPosts(this.props.blog.lastPage + 1);
        window.history.replaceState(null, document.title, event.target.href);
    }

    getPosts(page = 1) {
        this.props.actions.getPosts(this.props.articleType, page, this.state.selectedSection, this.state.selectedTags);
    }

    selectSection(event, section) {
        event.preventDefault();
        if(this.state.selectedSection === section) {
            //unselect it
            section = null;
        }
        this.setState({
            selectedSection: section
        }, this.getPosts);
    }

    toggleTag(event, tag) {
        event.preventDefault();
        let selectedTags = [...this.state.selectedTags];
        if(!selectedTags.find(t => t === tag)) {
            selectedTags.push(tag);
        }
        else {
            pull(selectedTags, tag);
        }
        this.setState({
            selectedTags
        }, this.getPosts);
    }

    applyFilter() {
        //send sections or tag to the server    
    }

    getSectionClass(section) {
        return this.state.selectedSection === section ? 'selected' : '';
    
    }

    getTagClass(tag) {
        return this.state.selectedTags.find(t => t === tag) ? 'selected' : '';
    }

    getTitle() {
        if(this.props.articleType == articleTypes.general) {
            return 'Music Blog - Music Discovery, Music Trends, and More! - LoudUp';
        }
        else if(this.props.articleType == articleTypes.unsigned) {
            return 'Unsigned Bands - How To Take Your Music Career To The Next Level - LoudUp';
        }
        else {
            return 'Discover New Music - Reviews and Interviews with Independent Artists - LoudUp';
        }
    }

    getMetaDescription() {
        if(this.props.articleType == articleTypes.general) {
            return 'Read our latest articles on music related topics such as the music industry, new trends, and music discovery.';
        }
        else if(this.props.articleType == articleTypes.unsigned) {
            return 'Advice and tips for unsigned bands and artists to help you take your music career to the next level. Covering topics such as getting exposure, live performance, production, opportunities, and more!';
        }
        else {
            return 'Discover new bands and artists, find out all about the music and the people behind it!';
        }
    }

    getHeader() {
        if(this.props.articleType == articleTypes.discover) {
            return 'Discover new music';
        }
        else if(this.props.articleType === articleTypes.unsigned) {
            return 'Unsigned Bands';
        }
    }

    getIntro() {
        if(this.props.articleType === articleTypes.discover) {
            return 'Discover new bands and artists, find out all about the music and the people behind it';
        }
        else if(this.props.articleType === articleTypes.unsigned) {
            return 'Advice and tips for unsigned bands and artists to help you take your music to the next level';
        }
    }

    render() {
        const title = this.getTitle();
        const description = this.getMetaDescription();
        const url = ShareService.getAbsoluteUrl(this.props.match.url);
        return (
            <div className="main blog">     
                <MetaTags>
                    <title>{title}</title>            
                    <meta id="description" name="description" content={description} />   
                    <meta id="og-url" property="og:url" content={url} />
                    <meta id="og-description" property="og:description" content={description} />
                    <meta id="twitter-url" name="twitter:url" content={url} />
                    <meta id="twitter-title" name="twitter:title" content={title} />
                    <meta id="twitter-description" name="twitter:description" content={description} />  
                </MetaTags>
                <link href="https://fonts.googleapis.com/css?family=Open+Sans" rel="stylesheet" type="text/css" />
                <div className="container">
                    <div className="block-inner minimal-height">   
                        <div className="blog-content">
                            {
                                this.props.articleType == articleTypes.discover || this.props.articleType == articleTypes.unsigned ?
                                    <React.Fragment>
                                        <h1 className="section-alt">{this.getHeader()}</h1>
                                        <p className="sectintro">{this.getIntro()}</p>
                                    </React.Fragment>
                                    : null
                            }
                            <div className="row">
                                <div className="col-md-8">
                                    <div id="blogSummaryContainer">
                                    {
                                        <div className="blogcol">
                                            {
                                                this.props.blog.items.length ?
                                                    this.props.articleType == articleTypes.general || this.props.articleType == articleTypes.unsigned ?
                                                        this.props.blog.items.map(blogItem =>
                                                            <BlogSummaryItem key={blogItem.Link} item={blogItem} articleType={this.props.articleType} />
                                                        )
                                                        :
                                                        null //discover       
                                                    :
                                                    this.props.blog.loadingStatus && this.props.blog.loadingStatus.status == 'LOADING' ? 
                                                        <Loading />  
                                                    : 
                                                        this.props.blog.loadingStatus && this.props.blog.loadingStatus.status == 'FAILED' ? 
                                                            <p>Sorry, something went wrong! Unable to load articles.</p>
                                                        :
                                                            <p>No articles found</p>
                                            }    
                                        </div>
                                    }
                                    {this.props.blog.haveNextPage ?
                                        this.props.blog.loadingStatus.status == 'LOADING' && this.props.blog.loadingStatus.page > 1 ?
                                            <Loading /> 
                                            :
                                            <React.Fragment>
                                                <div id="divLoadNext" style={{textAlign:'center'}}>
                                                    <a id="btnLoadNext" href={`${this.props.location.pathname}?page=${this.props.blog.lastPage + 1}`} className="btn btn-outline transition" style={{marginTop:'15px'}} onClick={this.loadNextPage}>Show More...</a>
                                                </div>
                                                {
                                                    this.props.blog.loadingStatus.status == 'FAILED' && this.props.blog.loadingStatus.page > 1 ?
                                                        <p style={{ textAlign: 'center', paddingTop: '20px' }}>Sorry, something went wrong! Unable to load more articles</p>
                                                        : null
                                                }
                                            </React.Fragment>
                                        : null
                                    }
                                    </div>
                                </div> 

                                <div id="blogFilter" className="col-md-4">
                                    <div className="content-side-2">
                                        <Advert adType="Square" />
                                    </div>
                                    <div className="blogsidebox">
                                        {
                                            this.props.blog.sections.length ?
                                            <div className="blogsect">
                                                <h3>Sections</h3>
                                                <ul className="list-unstyled">
                                                {
                                                    this.props.blog.sections.map(section =>
                                                        <li key={section}>
                                                            <a href={null} className={`transition ${this.getSectionClass(section)}`} onClick={(event) => this.selectSection(event, section)} style={{cursor: 'pointer'}}>{section}</a>
                                                        </li>
                                                    )
                                                }
                                                </ul>
                                            </div>
                                            : null
                                        }
                                        {
                                            this.props.blog.tags.length ?
                                            <div className="blogsect">
                                                <h3>Tags</h3>
                                                <div className="tags">
                                                {
                                                    this.props.blog.tags.map(tag =>
                                                        <a key={tag} href={null} className={`transition ${this.getTagClass(tag)}`} onClick={(event) => this.toggleTag(event, tag)} style={{cursor: 'pointer'}}>{tag}</a>
                                                    )
                                                }
                                                </div>
                                            </div>
                                            : null
                                        }                                        
                                    </div>
                                </div>
                            </div>  
                        </div>                   
                    </div>
                </div>
            </div>
        );
    }
}

BlogPage.propTypes = {
    articleType: PropTypes.string.isRequired,
    blog: PropTypes.object,
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let articleType = '';
    if(ownProps.match.path == '/Blog') {
        articleType = articleTypes.general;
    } 
    else if(ownProps.match.path == '/Unsigned') {
        articleType = articleTypes.unsigned;
    } 
    else {
        articleType = articleTypes.discover;
    }
    return { articleType, blog: state.blog[articleType] };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, blogActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BlogPage);
